var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { z } from 'zod';
import { objectValues } from 'utils/TypescriptUtils';
export var FLAGS = {
    SCROLLING_SCOREBOARD: 'scrolling_scoreboard',
    TEST: 'test',
    // SCO-359: route goal saves to the Node /api/v1/goals endpoint instead of
    // legacy PHP /rest_goals. Default-off → PHP; flip on per environment after
    // verifying Node; flipping off is an instant rollback.
    GOAL_WRITE_NODE: 'goal_write_node',
    // SCO-384: show the coach one-tap "Nudge" button on the per-producer card.
    // Default-off → ships dark until the SCO-383 Node route is deployed + the
    // AI Coach cohort is live; flipping off instantly hides the button.
    NUDGE_BUTTON: 'nudge_button',
    // SCO-392: render the player area inside the unified coach shell (SidebarProvider
    // + full-width Header + role-driven rail) instead of the legacy player layout.
    // Default-off → players stay on the current layout; flip on per-cohort only once
    // the parity gate (Score/Settings/real-time) is verified. Instant rollback.
    UNIFIED_PLAYER_SHELL: 'unified_player_shell',
    // Producer Readiness Panel (locked 2026-07-02): coach-area view of the
    // per-person enablement funnel (GET /api/v1/coach/readiness). Default-off →
    // nav item + route ship dark until the backend endpoint is deployed;
    // flipping off instantly hides the surface.
    READINESS_PANEL: 'readiness_panel',
    // SCO-552/SCO-559: route roster writes (add player, add/remove team member)
    // to the Node endpoints instead of legacy PHP /rest_users and
    // /rest_teams/{add,remove}_user. Default-off → PHP; flip on per environment
    // once the Node routes are deployed. Flipping off is an instant rollback.
    // NOTE: while this is off, the PHP paths are still live, and only add_user
    // has its ownership ladder restored (scoreboard#152) — remove_user stays
    // unguarded until this flag is on everywhere and the PHP methods are deleted.
    ROSTER_WRITE_NODE: 'roster_write_node'
};
// The store's runtime data is LaunchDarkly's allFlags(), which is keyed by
// the LD flag keys — the FLAGS *values*. The schema was previously built from
// the constant NAMES, inverting the type against the runtime data: a
// type-correct call like flag('READINESS_PANEL') compiled but always returned
// false, and every working call site needed a `FLAGS.X as 'X'` cast to smuggle
// the runtime value past the wrong type. Keying by values makes
// flag(FLAGS.READINESS_PANEL) both type-correct and runtime-correct.
var _a = objectValues(FLAGS), firstFlag = _a[0], otherFlags = _a.slice(1);
var KnownFlagSchema = z.enum(__spreadArray([firstFlag], otherFlags, true));
export var FlagsSchema = z.record(KnownFlagSchema, z.boolean());
